export const ImagotipoOrders = () => {
    return (
        <svg width="24" height="26" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.2168" y="1.58887" width="22.7832" height="21.3222" rx="2" stroke="#003366" strokeWidth="2" />
            <path d="M7.4668 0.588867H17.7499V6.13232C17.7499 6.68461 17.3022 7.13232 16.7499 7.13232H8.4668C7.91451 7.13232 7.4668 6.68461 7.4668 6.13232V0.588867Z" fill="#183555" />
        </svg>
    )
}